<template>
  <div class="dashboard-card gradient">
    <crisis-header :college-has-crisis-phone-feature="collegeHasCrisisPhoneFeature()" />
    <crisis-blurb
      :college-has-crisis-phone-feature="collegeHasCrisisPhoneFeature()"
      :college="college()"
    />
    <img
      class="upcoming__img img-fluid mt-4"
      src="@/assets/img/resource@2x.png"
      alt="BetterMynd Resources"
    />
  </div>
</template>

<script>
import CrisisHeader from './crisis-header.vue';
import CrisisBlurb from './crisis-blurb.vue'

export default {
  name: 'CrisisSideBar',
  components: {
    CrisisHeader,
    CrisisBlurb
  },
  methods: {
    college() {
      return this.$store.getters.currentUser.school;
    },
    collegeHasCrisisPhoneFeature() {
      return !!this.college().bettermynd_crisis_phone;
    }
  },
}
</script>

<style lang="scss" scoped>
.gradient {
  @include blue-gradient;

  p {
    color: rgba(white, 0.87);
  }

  b {
    margin-bottom: 3px;
    display: block;
  }

  a {
    display: block;
    margin-bottom: 5px;

    &:hover {
      color: $green;
      text-decoration: underline;
    }
  }
}
</style>
